import React from "react";

export default function FormattedDate(props) {

    let date = new Date();
    let hour = date.getHours();
	let minutes = date.getMinutes();

	let days = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	];
	let day = days[date.getDay()];

	let months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	let month = months[date.getMonth()];
	let dayOfMonth = date.getDate();

	if (minutes < 10) {
		minutes = `0${minutes}`;
	}

	if (hour < 10) {
		hour = `0${hour}`;
	}

	return <div>{day} {dayOfMonth} {month}</div>;
}